export default __webpack_public_path__ + "static/media/webwine.3a23f074.png";